import { render, staticRenderFns } from "./houseCode.vue?vue&type=template&id=887a8b98&scoped=true&"
import script from "./houseCode.vue?vue&type=script&lang=js&"
export * from "./houseCode.vue?vue&type=script&lang=js&"
import style0 from "./houseCode.vue?vue&type=style&index=0&id=887a8b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887a8b98",
  null
  
)

export default component.exports